// generate from swagger
export enum Features {
  User = 'user',
  Supplier = 'supplier',
  Approval = 'approval',
  Form = 'form',
  Auditing = 'auditing',
  Dashboard = 'dashboard',
  Reporting = 'reporting',
  Request = 'request',
}

export enum Permissions {
  Create = 'create',
  Read = 'read',
  Update = 'update',
  Delete = 'delete',
  Approve = 'approve',
  ReadOwn = 'readOwn',
  UpdateOwn = 'updateOwn',
  UpdateInternalSection = 'updateInternalSection',
  UpdateInitialSupplierDetails = 'updateInitialSupplierDetails',
  readSupplier = 'readSupplier',
}
